export default (length, placeholder) => {
    if (length === 1) return `1 ${placeholder}`;
    return `${length} ${placeholder}s`;
};
